import { useLocation, Redirect } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";

// Vision UI Dashboard React example components
import Footer from "examples/Footer";
import BasicLayout from "../components/BasicLayout";

import SecurityDevice from "./components/SecurityDevice";

function DashSecurityDevice() {
  return (
    <BasicLayout
      gotoPage="/admin"
      action={{
        type: "internal",
        label: "Logout",
        route: "/",
        exec: () => {
          localStorage.clear();
        },
        color: "white",
      }}
    >
      <Grid item xs={12} lg={7} xl={12}>
        <SecurityDevice />
      </Grid>
      <Footer />
    </BasicLayout>
  );
}

function CheckLogin() {
  const location = useLocation();
  const isLoggedStorage = localStorage.getItem("logged");
  return isLoggedStorage ? (
    <DashSecurityDevice />
  ) : (
    <Redirect
      to={
        "/login?redirect=" +
        location.pathname +
        (location.search !== "" ? `${location.search}` : "")
      }
    />
  );
}

export default CheckLogin;
